import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from '../../../utils/APIClient';
import {API_URL} from '../../../settings/local_settings';
import {FaIcon} from '../../FaIcon';
import {Spinner} from '../../Spinner';
import {AgencyClientSelect} from '../../selects/AgencyClientSelect';
import {withTranslation} from 'react-i18next';


class ForkTemplateModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSlug: null,
            selectedClientId: null,
            creating: false,
            error: null,
        };

        this.handleSelectTemplate = this.handleSelectTemplate.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({selectedSlug: null, selectedClientId: null, creating: false, error: null});
            const templates = this.props.officialTemplates || [];
            if (templates.length === 1) {
                this.setState({selectedSlug: templates[0].slug});
            }
        }
    }

    handleSelectTemplate(slug) {
        this.setState({selectedSlug: slug, error: null});
    }

    handleClientChange(clientId) {
        this.setState({selectedClientId: clientId, error: null});
    }

    handleCreate() {
        const {selectedSlug, selectedClientId} = this.state;
        if (!selectedSlug || !selectedClientId) return;

        this.setState({creating: true, error: null});
        const body = {source_slug: selectedSlug, client_id: selectedClientId};
        new APIClient(API_URL + 'reports/templates/fork/').call('POST', body).then((data) => {
            this.setState({creating: false});
            if (data && data.status === 'OK') {
                const newId = data.data.id;
                this.props.toggle();
                if (this.props.onForkSuccess) {
                    this.props.onForkSuccess(newId);
                }
            } else {
                this.setState({error: data?.error_message || 'Error'});
            }
        });
    }

    render() {
        const {t, isOpen, toggle, officialTemplates, allAgencyClients, loadingClients} = this.props;
        const {selectedSlug, selectedClientId, creating, error} = this.state;

        return (
            <Modal isOpen={isOpen} toggle={toggle} className="fork-template-modal">
                <ModalHeader toggle={toggle}>
                    {t('templates.fork_modal_title')}
                </ModalHeader>
                <ModalBody className="fork-template-modal-body">
                    <div className="fork-modal-section">
                        <label className="fork-modal-label">{t('templates.fork_select_base')}</label>
                        <div className="fork-modal-templates-list">
                            {(officialTemplates || []).map(template => {
                                const isSelected = selectedSlug === template.slug;
                                return (
                                    <div
                                        key={template.slug}
                                        className={`fork-modal-template-card ${isSelected ? '-selected' : ''}`}
                                        onClick={() => this.handleSelectTemplate(template.slug)}
                                    >
                                        <div className="fork-modal-template-icon">
                                            <FaIcon iconName={template.icon || 'file-chart-line'}/>
                                        </div>
                                        <div className="fork-modal-template-content">
                                            <h4 className="fork-modal-template-name">{template.name}</h4>
                                            <p className="fork-modal-template-desc">{template.description}</p>
                                        </div>
                                        {isSelected && (
                                            <div className="fork-modal-template-check">
                                                <FaIcon iconName="circle-check"/>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {selectedSlug && (
                        <div className="fork-modal-section -client">
                            <label className="fork-modal-label">{t('templates.fork_select_client')}</label>
                            <AgencyClientSelect
                                allAgencyClients={allAgencyClients}
                                selectedAgencyClient={selectedClientId}
                                onAgencyClientChange={this.handleClientChange}
                                canCreateNewAgencyClient={false}
                                hideGoToAgencyClientsAssignment={true}
                                loading={loadingClients}
                            />
                            <p className="fork-modal-client-hint">
                                <FaIcon iconName="circle-info"/>
                                {t('templates.fork_client_hint')}
                            </p>
                        </div>
                    )}

                    {error && (
                        <div className="fork-modal-error">
                            <FaIcon iconName="circle-exclamation"/>
                            {error}
                        </div>
                    )}
                </ModalBody>
                <ModalFooter className="fork-template-modal-footer">
                    <button className="btn -negative" onClick={toggle}>
                        {t('client_reports.cancel')}
                    </button>
                    <button
                        className="btn -alt"
                        onClick={this.handleCreate}
                        disabled={!selectedSlug || !selectedClientId || creating}
                    >
                        {creating ? (
                            <><Spinner color="light" size="sm"/> {t('templates.fork_creating')}</>
                        ) : (
                            <><FaIcon iconName="code-fork"/> {t('templates.fork_create')}</>
                        )}
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
}

export const ForkTemplateModal = withTranslation()(ForkTemplateModalClass);
